// import external modules
import React, { lazy } from "react";
import { Route, Router, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PublicRoute from "./PublicRoute.js";
import { getNotifications } from "../services/socketInstance";
import { getSocialMedia } from "../redux/actions/api/apiAction";
import { store } from "../redux/storeConfig/store";
const createBrowserHistory = require("history").createBrowserHistory;

const LazyLogin = lazy(() => import("../views/pages/auth/login"));
const LazyEnterprice = lazy(() => import("../views/pages/enterprice"));
// const LazyEnterpriceFull = lazy(() => import("../views/pages/enterpriceFull"));
const LazyEnterpriceFull = lazy(() =>
  import("../views/pages/facelifting/newBusiness")
);
// const LazyLanding = lazy(() => import("../views/pages/landingPage"));
const NewLanding = lazy(() => import("../views/pages/facelifting/newLanding"));
const LazyHome = lazy(() => import("../views/pages/home"));
const LazyGyms = lazy(() => import("../views/pages/gyms.js"));
const LazyPersonalTrainer = lazy(() =>
  import("../views/pages/personalTrainer.js")
);
const LazyTraining = lazy(() => import("../views/pages/training"));
const LazyLiveStream = lazy(() => import("../views/pages/liveStream"));
const LazyAccountInfo = lazy(() => import("../views/pages/accountInfo"));
const LazyCheckout = lazy(() => import("../views/pages/checkout"));
const LazyPackageCheckout = lazy(() =>
  import("../views/pages/packageCheckout")
);
const LazyQuestionnaire = lazy(() => import("../views/pages/questionnaire"));

const LazyCheckoutResult = lazy(() => import("../views/pages/checkoutResult"));
const LazyCardCheckoutResult = lazy(() =>
  import("../views/pages/cardCheckoutResult")
);
const LazyTerms = lazy(() => import("../views/pages/terms"));
const LazyWaivers = lazy(() => import("../views/pages/waivers"));

const LazyPrivacy = lazy(() => import("../views/pages/privacy"));

const LazySettingAndPrivacy = lazy(() =>
  import("../views/pages/settingAndPrivacy")
);
const LazyAccountInfoEdit = lazy(() =>
  import("../views/pages/accountInfoEdit")
);
const LazyMobileCheckOut = lazy(() =>
  import("../views/pages/mobilePackageCheckout")
);
const LazyMobileCheckOutStatus = lazy(() =>
  import("../views/pages/mobileCheckoutResult")
);

const LazyMobilePaymentSuccess = lazy(() =>
  import("../views/pages/mobilePaymentSuccess")
);
const LazyMobilePaymentFailed = lazy(() =>
  import("../views/pages/mobiePaymentFailed")
);
const LazyForgotPassword = lazy(() =>
  import("../views/pages/auth/forgotPassword")
);
const LazyReSetPassword = lazy(() =>
  import("../views/pages/auth/resetPassword")
);
const LazyRecaptcha = lazy(() => import("../views/pages/recaptcha"));
const LazyRecaptchaSuccess = lazy(() =>
  import("../views/pages/success-recaptcha")
);
const LazyRecaptchaFailed = lazy(() =>
  import("../views/pages/failed-recaptcha")
);
export const history = createBrowserHistory({
  basename: "/",
});
const LazyGymDetails = lazy(() => import("../views/pages/gymDetails"));
const LazyPersonalTrainerDetails = lazy(() =>
  import("../views/pages/personalTrainerInfo")
);
const LazyUserInfo = lazy(() => import("../views/pages/userInfo"));
const LazySucessCase = lazy(() => import("../views/pages/successCase"));
const LazyLoader = lazy(() => import("../components/spinner/spinner"));
const LazyLiveClass = lazy(() => import("../views/pages/liveClass"));

class AppRouter extends React.Component {
  componentDidMount = async () => {
    if (this.props.isAuthenticated) {
      getNotifications();
    }
    store.dispatch(getSocialMedia());
  };
  render() {
    const { isAuthenticated, direction } = this.props;
    return (
      <Router history={history}>
        <div dir={direction}>
          <Switch>
            <PublicRoute path="/login" component={LazyLogin} exact={true} />
            <PublicRoute
              path="/recaptcha"
              component={LazyRecaptcha}
              exact={true}
              noLayout={true}
            />
            <PublicRoute
              path="/success-recaptcha"
              component={LazyRecaptchaSuccess}
              exact={true}
              noLayout={true}
            />
            <PublicRoute
              path="/failed-recaptcha"
              component={LazyRecaptchaFailed}
              exact={true}
              noLayout={true}
            />
            {/* <PublicRoute
              path="/"
              component={LazyLanding}
              exact={true}
              fulllayout={true}
            /> */}
            {/* <PublicRoute
              path="/"
              component={NewLanding}
              exact={true}
              fulllayout={true}
            /> */}
            <PublicRoute
              path="/"
              component={LazyEnterpriceFull}
              exact={true}
              fulllayout={true}
            />
            <Route
              path="/mobile-checkout"
              component={LazyMobileCheckOut}
              exact={true}
            />
            <Route
              path="/mobile-result"
              component={LazyMobileCheckOutStatus}
              exact={true}
            />
            <Route
              path="/mobile-payment-success"
              component={LazyMobilePaymentSuccess}
              exact={true}
            />
            <Route
              path="/mobile-payment-failed"
              component={LazyMobilePaymentFailed}
              exact={true}
            />
            <PublicRoute
              path="/landing"
              component={LazyEnterprice}
              exact={true}
              fulllayout={true}
            />
            <PublicRoute
              path="/customer"
              component={LazyHome}
              exact={true}
              fulllayout={false}
            />
            <PublicRoute
              path="/gyms"
              component={LazyGyms}
              exact={true}
              fulllayout={false}
            />
            <PublicRoute
              path="/personaltrainer"
              component={LazyPersonalTrainer}
              exact={true}
              fulllayout={false}
            />
            <PublicRoute
              path="/liveClass"
              component={LazyLiveClass}
              exact={true}
            />
            <PublicRoute
              path="/livestream"
              component={LazyLiveStream}
              exact={true}
              fulllayout={false}
            />
            <PublicRoute
              path="/training"
              component={LazyTraining}
              exact={true}
              fulllayout={true}
            />
            <PublicRoute
              path="/questionnaire"
              component={LazyQuestionnaire}
              exact={true}
              fulllayout={true}
              hideFooter={true}
            />

            {isAuthenticated && (
              <PublicRoute
                path="/accountinfo"
                component={LazyAccountInfo}
                exact={true}
                fulllayout={false}
              />
            )}
            {isAuthenticated && (
              <PublicRoute
                path="/accountinfoedit"
                component={LazyAccountInfoEdit}
                exact={true}
                fulllayout={false}
              />
            )}
            {isAuthenticated && (
              <PublicRoute
                path="/setting"
                component={LazySettingAndPrivacy}
                exact={true}
                fulllayout={false}
              />
            )}
            <PublicRoute
              path="/gyms/:id"
              component={LazyGymDetails}
              exact={true}
              fulllayout={false}
            />
            <PublicRoute
              path="/customer"
              component={LazyHome}
              exact={true}
              fulllayout={false}
            />
            <PublicRoute
              path="/personaltrainer/:id"
              component={LazyPersonalTrainerDetails}
              exact={true}
              fulllayout={false}
            />
            {isAuthenticated && (
              <PublicRoute
                path="/checkout/package/:id"
                component={LazyPackageCheckout}
                exact={true}
                fulllayout={false}
              />
            )}
            {isAuthenticated && (
              <PublicRoute
                path="/checkout/:id"
                component={LazyCheckout}
                exact={true}
                fulllayout={false}
              />
            )}
            {isAuthenticated && (
              <PublicRoute
                path="/result"
                component={LazyCheckoutResult}
                exact={true}
                fulllayout={false}
              />
            )}
            {isAuthenticated && (
              <PublicRoute
                path="/cardResult"
                component={LazyCardCheckoutResult}
                exact={true}
                fulllayout={false}
              />
            )}
            {isAuthenticated && (
              <PublicRoute
                path="/userinfo"
                component={LazyUserInfo}
                exact={true}
                fulllayout={false}
              />
            )}
            <PublicRoute
              path="/sucesscase"
              component={LazySucessCase}
              exact={true}
              fulllayout={false}
            />
            <PublicRoute
              path="/loader"
              component={LazyLoader}
              exact={true}
              fulllayout={false}
            />

            <PublicRoute
              path="/terms"
              component={LazyTerms}
              exact={true}
              fulllayout={false}
            />
            <PublicRoute
              path="/waivers"
              component={LazyWaivers}
              exact={true}
              fulllayout={false}
            />
            <PublicRoute
              path="/privacy-policy"
              component={LazyPrivacy}
              exact={true}
              fulllayout={false}
            />
            <PublicRoute
              path="/recaptcha"
              component={LazyRecaptcha}
              exact={true}
              fulllayout={false}
            />
            <Route path="*" render={() => <Redirect to="/" />} />
          </Switch>
        </div>
      </Router>
    );
  }
}

const mapStateToProps = (state) => {
  const isAuthenticated = state.login.loginFlag;
  const { direction } = state.languageDirectionData;
  return { isAuthenticated, direction };
};

export default connect(mapStateToProps, {})(AppRouter);
